/** Fixes currency labels when UTF-8 euro (€) was stored/read as Latin-1 (â‚¬). */
export function normalizeCurrencyLabel(currency: string | null | undefined): string {
  if (!currency?.trim()) return 'EUR €';

  let value = currency.trim()
    .replace(/â‚¬/g, '€')
    .replace(/Â€/g, '€')
    .replace(/\uFFFD/g, '€');

  return value.trim() || 'EUR €';
}
